import request from '@/utils/request'
// 检验手机号
export function CheckPhone(data) {
    return request({
        url:'/netbar/api/user/v1/check_phone',
        method:'post',
        data
    })
}
// 发送验证码
export function sendCode(data) {
    return request({
        url:'/netbar/api/user/v1/send_code',
        method:'post',
        data
    })
}
// 登录
export function register(data) {
    return request({
        url:'/netbar/api/user/v1/login',
        method:'post',
        data
    })
}
// 用户协议 
export function userAgreement(data) {
    return request({
        url:'/admin/h5/get_user_agreement',
        method:'post',
        data
    })
}


// 根据code 获取用户信息
export function getUserInfo(data) {
    return request({
        url:'/netbar/api/user/v1/select_by_open_id',
        method:'post',
        data
    })
}